import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Chip,
  LinearProgress,
  Grid,
  Tabs,
  Tab,
  Container,
  Paper,
  Divider,
  useTheme,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  InputAdornment,
  CircularProgress,
  MenuItem,
  Select,
  FormControl,
  Alert,
  Skeleton,
} from "@mui/material";
import {
  TrendingUp,
  TrendingDown,
  Close as CloseIcon,
  Lock,
  ChevronRight,
} from "@mui/icons-material";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";

import {
  USER_ENGAGEMENT_ENDPOINT,
  DAILY_USAGE_ANALYTICS_ENDPOINT,
  WHATSAPP_SCHEDULED_BROADCAST_LOG_ENDPOINT,
  GET_WALLET_STATS,
  GET_WALLET_MONTHLY_SPEND,
  GET_WALLET_INITIATE_CASHFREE_ENDPOINT,
  TEMPLATE_STATUS_ENDPOINT,
  GET_DASHBOARD_WABA_STATUS,
  GET_DASHBOARD_AUDIENCE_DATA,
  GET_HOLIDAY_LIST_ENDPOINT,
  GET_TENANT_DETAILS,
  GET_RCS_BRAND,
  GET_SUBSCRIPTIONS,
} from "../../config/urls";

import { useAuth } from "../../hooks/AuthProvider";
import { format, parseISO, startOfMonth } from "date-fns";
import { load } from "@cashfreepayments/cashfree-js";
import { CASHFREE_MODE } from "../../config/environment";
import ButtonOne from "../../common/normal-button";
import {
  ColorsConstants,
  dashboardCardGreenTextColor,
  grayFontColor,
} from "../../cssUtils/constants";
import DashboardTabLabel from "../../common/dashboard-tab-labels";
import DashboardStatSection from "../../common/dashboard-stat-section";

import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import DashboardBadge from "../../common/dashboard-badges";
import { ReactComponent as BroadcastLogo } from "../../assets/images/icons/dashboard/bandwidth.svg";
import { ReactComponent as WalletLogo } from "../../assets/images/icons/dashboard/wallet.svg";
import { ReactComponent as CalendarLogo } from "../../assets/images/icons/dashboard/calendar.svg";
import { ReactComponent as ContactsLogo } from "../../assets/images/icons/dashboard/contacts.svg";
import { ReactComponent as GraphLogo } from "../../assets/images/icons/dashboard/graph.svg";
import { ReactComponent as SettingsLogo } from "../../assets/images/icons/dashboard/settings.svg";
import ButtonTwo from "../../common/dashboard-button";

// Import typography
import typography from "../../cssUtils/typography";
import AppDropdown from "../../common/app-dropdown";
import AppChip from "../../common/app-chip";
import axios from "axios";
import { formatWithTzLabel } from "../../utils/dateUtils";

// Countries the Campaign Calendar has holiday data for — keep in sync with
// SUPPORTED_HOLIDAY_COUNTRY_CODES in dashboard/views.py (backend).
const HOLIDAY_COUNTRY_OPTIONS = [
  { label: "India", value: "in" },
  { label: "United Kingdom", value: "gb" },
  { label: "UAE", value: "ae" },
  { label: "Australia", value: "au" },
  { label: "Kenya", value: "ke" },
  { label: "US", value: "us" },
];
const HOLIDAY_COUNTRY_LABELS = Object.fromEntries(
  HOLIDAY_COUNTRY_OPTIONS.map(({ label, value }) => [value, label]),
);

const DashboardTab = (props) => {
  const { getValidToken } = useAuth();
  const tenant = localStorage.getItem("tenant");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const permissionsFromStorage = JSON.parse(
    localStorage.getItem("permissions") || "[]",
  );

  const [broadcastTab, setBroadcastTab] = useState(0);
  const [contactsTab, setContactsTab] = useState(0);
  const [lastBroadcastData, setLastBroadcastData] = useState({});
  const [loadingLastBroadcastData, setLoadingLastBroadcastData] =
    useState(false);
  const today = new Date();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [amount, setAmount] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [currentMonthSpend, setCurrentMonthSpend] = useState("");
  const cashfreeRef = useRef(null);
  const [billingCurrency, setBillingCurrency] = useState("INR");
  const [brands, setBrands] = useState();

  const [thisMonthUsageData, setThisMonthUsageData] = useState({
    totalCharges: 0,
    totalMessages: 0,
  });
  const [wabaPhoneNumber, setWabaPhoneNumber] = useState("");
  const [loadingWabaPhone, setLoadingWabaPhone] = useState(false);
  const [addons, setAddons] = useState([]);
  const addonNames = addons.map((a) => a.name);
  const isRCS = addonNames.some((name) =>
    ["rcs", "rcs_engage", "rcs_automate", "rcs_orchestrate"].includes(name),
  );
  const [templateStatus, setTemplateStatus] = useState({
    approved: 0,
    pending: 0,
  });

  const [summaryData, setSummaryData] = useState({
    messagesEnqueued: 0,
    messagesSent: 0,
    messagesDelivered: 0,
    messagesRead: 0,
    messagesFailed: 0,
    totalBroadcasts: 0,
  });

  const [businessData, setBusinessData] = useState({
    user_name: "",
    user_email: "",
    business_name: "",
    business_wa_number: "",
    wabaInfo: {},
  });

  const [usageData, setUsageData] = useState({
    marketing: 0,
    utility: 0,
    service: 0,
    authentication: 0,
    international: 0,
    totalCharges: 0,
  });

  const [scheduledBroadcasts, setScheduledBroadcasts] = useState([]);
  const [walletData, setWalletData] = useState(null);
  const [showAddFundsModal, setShowAddFundsModal] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [holidays, setHolidays] = useState([]);
  const [loadingHolidays, setLoadingHolidays] = useState(false);
  const [loadingDashboard, setLoadingDashboard] = useState(true);

  const [audienceData, setAudienceData] = useState({
    active: 0,
    quarter_to_date: 0,
    year_to_date: 0,
    regions: { data: [], total: 0 },
    audience_tags: 0,
    new_last_month: 0,
    growth: 0,
    new_this_month_from_chatbot: 0,
  });

  const [metrics, setMetrics] = useState({
    enqueuedToSentRate: 0,
    deliveryRate: 0,
    readRate: 0,
    failureRate: 0,
  });

  // Function to get currency symbol
  const getCurrencySymbol = (currencyCode) => {
    switch (currencyCode?.toUpperCase()) {
      case "USD":
        return "$";
      case "EUR":
        return "€";
      case "GBP":
        return "£";
      case "INR":
        return "₹";
      case "AED":
        return "د.إ";
      default:
        return "₹";
    }
  };

  // Function to format currency with proper symbol
  const formatCurrency = (value) => {
    const currencySymbol = getCurrencySymbol(billingCurrency);
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: billingCurrency,
      minimumFractionDigits: 2,
    })
      .format(value)
      .replace(/[A-Z]{3}/, currencySymbol);
  };

  // Simple format for display without full currency formatting
  const formatCurrencySimple = (value) => {
    const currencySymbol = getCurrencySymbol(billingCurrency);
    return `${currencySymbol}${value ? parseFloat(value).toFixed(2) : "0.00"}`;
  };

  const fetchWabaPhoneNumber = async () => {
    try {
      setLoadingWabaPhone(true);
      const token = await getValidToken();
      const tenant = localStorage.getItem("tenant");
      const headers = {
        "X-Tenant-Id": tenant,
        Authorization: `Bearer ${token}`,
      };

      const response = await fetch(GET_DASHBOARD_WABA_STATUS, { headers });

      if (!response.ok) {
        throw new Error("Failed to fetch WABA data");
      }

      const responseData = await response.json();

      if (responseData?.wabaInfo?.phone) {
        setWabaPhoneNumber(responseData.wabaInfo.phone);
      }
    } catch (error) {
      console.error("Error fetching WABA phone number:", error);
      setWabaPhoneNumber("");
    } finally {
      setLoadingWabaPhone(false);
    }
  };

  const fetchMonthlySpend = async () => {
    try {
      const data = await apiRequest(GET_WALLET_MONTHLY_SPEND);
      setCurrentMonthSpend(data?.current_month_spend || 0);
    } catch (error) {
      console.error("Error fetching monthly spend:", error);
    }
  };

  const fetchTenantDetails = async () => {
    try {
      const token = await getValidToken();
      const tenant = localStorage.getItem("tenant");

      const response = await fetch(GET_TENANT_DETAILS, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "X-Tenant-ID": tenant,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (
        data.results &&
        data.results.length > 0 &&
        data.results[0].billing_currency
      ) {
        setBillingCurrency(data.results[0].billing_currency);
      }
    } catch (error) {
      console.error("Error fetching tenant details:", error);
    }
  };

  const fetchScheduledBroadcasts = async () => {
    try {
      const token = await getValidToken();
      const tenant = localStorage.getItem("tenant");

      const queryParams = new URLSearchParams({
        limit: "20",
        offset: "0",
        audience_type: "csv,segment",
        status: "Scheduled,Created",
        ordering: "desc",
      });

      const response = await fetch(
        `${WHATSAPP_SCHEDULED_BROADCAST_LOG_ENDPOINT}?${queryParams}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "X-Tenant-Id": tenant,
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch scheduled broadcasts");
      }

      const jsonData = await response.json();
      setScheduledBroadcasts(jsonData.results || []);
    } catch (error) {
      console.error("Error fetching scheduled broadcasts:", error.message);
      setScheduledBroadcasts([]);
    }
  };

  const fetchTemplateStatus = async () => {
    try {
      const token = await getValidToken();
      const tenant = localStorage.getItem("tenant");

      const response = await fetch(TEMPLATE_STATUS_ENDPOINT, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "X-Tenant-Id": tenant,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch template status");
      }

      const jsonData = await response.json();

      if (jsonData.status === "success") {
        setTemplateStatus(jsonData.data);
      }
    } catch (error) {
      console.error("Error fetching template status:", error.message);
      setTemplateStatus({
        approved: 0,
        pending: 0,
      });
    }
  };

  const formatPhoneNumber = (phone) => {
    if (!phone) return "+1 (555) 123-4567";
    const cleaned = phone.replace(/\D/g, "");
    if (cleaned.length === 10) {
      return `+1 (${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    } else if (cleaned.length === 11 && cleaned.startsWith("1")) {
      return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7, 11)}`;
    }
    return phone;
  };

  const fetchBrands = async () => {
    try {
      const headers = { "X-Tenant-ID": localStorage.getItem("tenant") || "" };
      // NOTE: Adjust this URL path if your brands endpoint is mounted differently
      const response = await axios.get(GET_RCS_BRAND, { headers });
      const data = response.data.results || response.data;
      setBrands(Array.isArray(data) ? data[0]?.brand_name : []);
    } catch (err) {
      console.error("Failed to fetch brands", err);
    }
  };

  const loadCurrentSubscription = async () => {
    const token = await getValidToken();

    try {
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "X-Tenant-Id": tenant,
      };

      const subscriptionResponse = await fetch(GET_SUBSCRIPTIONS, {
        headers,
      });

      const data = await subscriptionResponse.json();
      setAddons(data?.addons);
    } catch (err) {
      console.error("Unexpected error loading subscription:", err);
    }
  };

  useEffect(() => {
    const loadAllData = async () => {
      try {
        await Promise.allSettled([
          fetchUserEngagementData(),
          fetchUsageData(),
          fetchScheduledBroadcasts(),
          fetchWalletData(),
          fetchThisMonthUsageData(),
          fetchTemplateStatus(),
          fetchBusinessData(),
          fetchAudienceData(),
          fetchHolidayData(),
          fetchTenantDetails(),
          fetchMonthlySpend(),
          fetchWabaPhoneNumber(),
          fetchBrands(),
          loadCurrentSubscription(),
        ]);
      } catch (error) {
        console.error("Error loading dashboard data:", error);
      } finally {
        setLoadingDashboard(false);
      }
    };
    loadAllData();
  }, []);

  useEffect(() => {
    const initializeSDK = async () => {
      if (typeof window === "undefined") return;

      try {
        const cf = await load({ mode: CASHFREE_MODE });
        if (!cf) {
          console.error("❌ SDK load() returned null");
          return;
        }
        cashfreeRef.current = cf;
      } catch (e) {
        console.error("❌ Failed to load SDK:", e);
      }
    };

    initializeSDK();
  }, []);

  const fetchAudienceData = async () => {
    try {
      const token = await getValidToken();
      const fetchURL = GET_DASHBOARD_AUDIENCE_DATA;
      const headers = {
        "X-Tenant-Id": tenant,
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await fetch(fetchURL, { headers });

      if (!response.ok) {
        throw new Error("Failed to fetch audience data");
      }

      const responseData = await response.json();

      setAudienceData({
        active: responseData?.active || 0,
        quarter_to_date: responseData?.quarter_to_date || 0,
        year_to_date: responseData?.year_to_date || 0,
        regions: responseData?.regions || { data: [], total: 0 },
        audience_tags: responseData?.audience_tags || 0,
        new_last_month: responseData?.last_month_audience_count || 0,
        growth: responseData?.growth_percent || 0,
        new_this_month_from_chatbot: responseData?.new_this_month_chatbot || 0,
      });
    } catch (error) {
      console.error("Error fetching audience data:", error);
      setAudienceData({
        active: 0,
        quarter_to_date: 0,
        year_to_date: 0,
        regions: { data: [], total: 0 },
      });
    }
  };

  const fetchBusinessData = async () => {
    try {
      const token = await getValidToken();
      const fetchURL = GET_DASHBOARD_WABA_STATUS;
      const tenant = localStorage.getItem("tenant");
      const headers = {
        "X-Tenant-Id": tenant,
        Authorization: `Bearer ${token}`,
      };

      const response = await fetch(fetchURL, { headers });

      if (!response.ok) {
        throw new Error("Failed to fetch business data");
      }

      const responseData = await response.json();

      setBusinessData({
        user_name: responseData?.user_name || "",
        user_email: responseData?.user_email || "",
        business_name: responseData?.business_name || "",
        business_wa_number: responseData?.business_wa_number || "",
        wabaInfo: responseData?.wabaInfo || {},
      });
    } catch (error) {
      console.error("Error fetching business data:", error);
      setBusinessData({
        user_name: "",
        user_email: "",
        business_name: "",
        business_wa_number: "",
        wabaInfo: {},
      });
    }
  };

  const fetchThisMonthUsageData = async () => {
    try {
      const token = await getValidToken();
      const tenant = localStorage.getItem("tenant");

      const startOfMonthDate = startOfMonth(new Date());
      const endOfMonthDate = new Date();

      const startDateStr = format(startOfMonthDate, "yyyy-MM-dd");
      const endDateStr = format(endOfMonthDate, "yyyy-MM-dd");

      const queryParams = new URLSearchParams({
        from_date: startDateStr,
        to_date: endDateStr,
      });

      const response = await fetch(
        `${DAILY_USAGE_ANALYTICS_ENDPOINT}?${queryParams}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "X-Tenant-Id": tenant,
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch this month usage data");
      }

      const jsonData = await response.json();

      const thisMonthSummary = (jsonData.usage || []).reduce(
        (acc, usage) => {
          acc.totalCharges += parseFloat(usage.total || 0);
          acc.totalMessages +=
            (usage.marketing || 0) +
            (usage.utility || 0) +
            (usage.services || 0) +
            (usage.authentication || 0);
          return acc;
        },
        {
          totalCharges: 0,
          totalMessages: 0,
        },
      );

      setThisMonthUsageData(thisMonthSummary);
    } catch (error) {
      console.error("Error fetching this month usage data:", error.message);
      setThisMonthUsageData({ totalCharges: 0, totalMessages: 0 });
    }
  };

  const fetchUserEngagementData = async () => {
    try {
      setLoadingLastBroadcastData(true);

      const startOfMonthDate = startOfMonth(new Date());
      const endOfMonthDate = new Date();

      const startDateStr = format(startOfMonthDate, "yyyy-MM-dd");
      const endDateStr = format(endOfMonthDate, "yyyy-MM-dd");

      const queryParams = new URLSearchParams({
        startDate: startDateStr,
        endDate: endDateStr,
      });

      const token = await getValidToken();
      const tenant = localStorage.getItem("tenant");
      const response = await fetch(
        `${USER_ENGAGEMENT_ENDPOINT}?${queryParams}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "X-Tenant-Id": tenant,
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const jsonData = await response.json();

      processEngagementData(jsonData);
      setLoadingLastBroadcastData(false);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setSummaryData({
        messagesEnqueued: 0,
        messagesSent: 0,
        messagesDelivered: 0,
        messagesRead: 0,
        messagesFailed: 0,
        totalBroadcasts: 0,
      });
      setLoadingLastBroadcastData(false);
    } finally {
      setLoadingLastBroadcastData(false);
    }
  };

  const [dateRange, setDateRange] = useState({
    startDate: startOfMonth(today),
    endDate: today,
    hasError: false,
  });

  const calculateMetricsFrom = (data) => {
    try {
      return {
        enqueuedToSentRate:
          data.messagesEnqueued > 0
            ? ((data.messagesSent / data.messagesEnqueued) * 100).toFixed(1)
            : 0,
        deliveryRate:
          data.messagesSent > 0
            ? (
                (data.delivered_read_count / data.totalBroadcasts) *
                100
              ).toFixed(1)
            : 0,
        readRate:
          data.messagesDelivered > 0
            ? ((data.messagesRead / data.messagesDelivered) * 100).toFixed(1)
            : 0,
        failureRate:
          data.messagesEnqueued > 0
            ? ((data.messagesFailed / data.messagesEnqueued) * 100).toFixed(1)
            : 0,
      };
    } catch (error) {
      console.error("Error calculating metrics:", error);
      return {
        enqueuedToSentRate: 0,
        deliveryRate: 0,
        readRate: 0,
        failureRate: 0,
      };
    }
  };

  const processEngagementData = (data) => {
    try {
      if (!data || !data.dailyStats) {
        return;
      }

      const summaryFromAPI = {
        messagesEnqueued: data.summary?.messagesEnqueued ?? 0,
        messagesSent: data.summary?.messagesSent ?? 0,
        messagesDelivered: data.summary?.messagesDelivered ?? 0,
        messagesRead: data.summary?.messagesRead ?? 0,
        messagesFailed: data.summary?.messagesFailed ?? 0,
        totalBroadcasts: data.summary?.campaignCount ?? 0,
        delivered_read_count: data.thisMonth?.delivered_read_count ?? 0,
      };

      const lastBroadcastData = {
        lastBroadcastCount: data.lastBroadcast?.last_broadcast_count,
        lastBroadcastTime: data.lastBroadcast?.last_broadcast_timestamp_iso,
        lastBroadcastDeliveryRate: data.lastBroadcast?.delivery_rate,
        lastBroadcastCost:
          data.lastBroadcast?.total_cost ??
          `${getCurrencySymbol(billingCurrency)}0.00`,
      };

      setSummaryData(summaryFromAPI);
      setMetrics(calculateMetricsFrom(summaryFromAPI));
      setLastBroadcastData(lastBroadcastData);
    } catch (error) {
      console.error("Error processing engagement data:", error);
      setSummaryData({
        messagesEnqueued: 0,
        messagesSent: 0,
        messagesDelivered: 0,
        messagesRead: 0,
        messagesFailed: 0,
        totalBroadcasts: 0,
      });
    }
  };

  const fetchUsageData = async () => {
    try {
      const startOfMonthDate = startOfMonth(new Date());
      const endOfMonthDate = new Date();

      const startDateStr = format(startOfMonthDate, "yyyy-MM-dd");
      const endDateStr = format(endOfMonthDate, "yyyy-MM-dd");

      const token = await getValidToken();
      const tenant = localStorage.getItem("tenant");

      const queryParams = new URLSearchParams({
        from_date: startDateStr,
        to_date: endDateStr,
      });

      const response = await fetch(
        `${DAILY_USAGE_ANALYTICS_ENDPOINT}?${queryParams}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "X-Tenant-Id": tenant,
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch usage data");
      }

      const jsonData = await response.json();

      const summary = (jsonData.usage || []).reduce(
        (acc, usage) => {
          acc.marketing += usage.marketing || 0;
          acc.utility += usage.utility || 0;
          acc.service += usage.services || 0;
          acc.authentication += usage.authentication || 0;
          acc.totalCharges += parseFloat(usage.total || 0);
          return acc;
        },
        {
          marketing: 0,
          utility: 0,
          service: 0,
          authentication: 0,
          international: 0,
          totalCharges: 0,
        },
      );

      setUsageData(summary);
    } catch (error) {
      console.error("Error fetching usage data:", error.message);
      setUsageData({
        marketing: 0,
        utility: 0,
        service: 0,
        authentication: 0,
        international: 0,
        totalCharges: 0,
      });
    }
  };

  const apiRequest = async (url, options = {}) => {
    try {
      const token = await getValidToken();
      const response = await fetch(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "X-Tenant-ID": localStorage.getItem("tenant"),
        },
        ...options,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    } catch (error) {
      console.error("API request error:", error);
      throw error;
    }
  };

  const walletAPI = {
    getWalletStats: () => apiRequest(GET_WALLET_STATS),
    getMonthlySpend: () => apiRequest(GET_WALLET_MONTHLY_SPEND),
  };

  const fetchWalletData = async () => {
    try {
      const data = await walletAPI.getWalletStats();
      setWalletData(data);
    } catch (error) {
      console.error("Error fetching wallet data:", error);
      setWalletData(null);
    }
  };

  const handleCancel = () => {
    setShowAddFundsModal(false);
    setShowConfirmModal(false);
    setAmount("");
  };

  const handleAmountSubmit = () => {
    try {
      if (amount && parseFloat(amount) > 0) {
        setShowAddFundsModal(false);
        setShowConfirmModal(true);
      }
    } catch (error) {
      console.error("Error submitting amount:", error);
    }
  };

  const handleConfirm = async () => {
    try {
      setSubmitting(true);
      const tenant = localStorage.getItem("tenant");
      const token = await getValidToken();

      const res = await fetch(`${GET_WALLET_INITIATE_CASHFREE_ENDPOINT}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "X-Tenant-ID": tenant,
        },
        body: JSON.stringify({ amount: parseInt(amount, 10) }),
      });

      const data = await res.json();

      if (data.payment_session_id && cashfreeRef.current) {
        try {
          cashfreeRef.current.checkout({
            paymentSessionId: data.payment_session_id,
            redirectTarget: "_self",
          });
        } catch (err) {
          console.error("Cashfree checkout error:", err);
        }
      }
    } catch (error) {
      console.error("Error initiating payment:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const StatusIndicator = ({ status }) => (
    <Box
      sx={{
        width: 8,
        height: 8,
        borderRadius: "50%",
        bgcolor:
          status === "connected"
            ? "success.main"
            : status === "warning"
              ? "warning.main"
              : "error.main",
        display: "inline-block",
        mr: 1,
      }}
    />
  );

  const formatStatus = (status) => {
    try {
      if (!status) return "Unknown";
      return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    } catch (error) {
      console.error("Error formatting status:", error);
      return "Unknown";
    }
  };

  const handleAddFunds = () => {
    setShowAddFundsModal(true);
  };

  const MetricRow = ({ label, value, trend, color = "text.primary" }) => (
    <Box sx={{ display: "flex", justifyContent: "space-between", py: 1.5 }}>
      <Typography
        sx={{
          ...typography.bodyLarge,
          color: "#505050",
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          ...typography.bodyLarge,
          fontWeight: 600,
          color: color === "text.primary" ? "#000000" : color,
          display: "flex",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        {value || "0"}
        {trend === "up" && <TrendingUp fontSize="small" color="success" />}
        {trend === "down" && <TrendingDown fontSize="small" color="error" />}
      </Typography>
    </Box>
  );

  const HolidayItem = ({ name, date, daysLeft, urgent }) => (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 1,
        bgcolor: "#F0F5FF",
        border: "1px solid #F0F5FF",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box>
        <Typography
          sx={{
            ...typography.bodyLarge,
            fontWeight: 600,
            color: "#000000",
          }}
        >
          {name}
        </Typography>
        <Typography
          sx={{
            ...typography.bodySmall,
            color: "#505050",
            mt: 0.5,
          }}
        >
          {date}
        </Typography>
      </Box>
      <AppChip
        label={`${daysLeft} days`}
        size="small"
        variant="filled"
        sx={{
          bgcolor:
            urgent === "urgent"
              ? "error.main"
              : urgent === "soon"
                ? "warning.main"
                : ColorsConstants.primaryBlue100,
          color:
            urgent === "urgent"
              ? "error.contrastText"
              : urgent === "soon"
                ? "warning.contrastText"
                : "#FFFFFF",
          fontWeight: 600,
        }}
      />
    </Paper>
  );

  const fetchHolidayData = async (country) => {
    try {
      setLoadingHolidays(true);
      const token = await getValidToken();
      const tenant = localStorage.getItem("tenant");

      // Omit `country` on the initial load so the backend derives it from
      // the tenant's configured country (TenantDetails) instead of always
      // defaulting to India; an explicit country is sent once the user
      // picks one from the dropdown.
      const queryParams = new URLSearchParams(
        country ? { country: country.toLowerCase() } : {},
      );

      const response = await fetch(
        `${GET_HOLIDAY_LIST_ENDPOINT}?${queryParams}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "X-Tenant-Id": tenant,
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch holiday data");
      }

      const holidayData = await response.json();

      setHolidays(holidayData.upcoming_holidays || []);
      if (holidayData.country) {
        setSelectedCountry(holidayData.country);
      }
    } catch (error) {
      console.error("Error fetching holiday data:", error.message);
      setHolidays([]);
    } finally {
      setLoadingHolidays(false);
    }
  };

  const handleCountryChange = (event) => {
    try {
      const newCountry = event.target.value;
      fetchHolidayData(newCountry);
    } catch (error) {
      console.error("Error changing country:", error);
    }
  };

  const formatHolidayDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch (error) {
      console.error("Error formatting holiday date:", error);
      return dateString;
    }
  };

  const getUrgencyLevel = (daysRemaining) => {
    try {
      if (daysRemaining <= 7) return "urgent";
      if (daysRemaining <= 30) return "soon";
      return "normal";
    } catch (error) {
      console.error("Error getting urgency level:", error);
      return "normal";
    }
  };

  const getHolidayEmoji = (holidayName) => {
    try {
      const emojiMap = {
        christmas: "🎄",
        "republic day": "🇮🇳",
        "maha shivaratri": "🕉️",
        shivaratri: "🕉️",
        holi: "🎨",
        diwali: "✨",
        dussehra: "🪔",
        "ganesh chaturthi": "🐘",
        eid: "🌙",
        thanksgiving: "🦃",
        "independence day": "🎆",
        "valentine's day": "💘",
        "new year": "🎊",
      };

      const lowerName = (holidayName || "").toLowerCase();
      for (const [key, emoji] of Object.entries(emojiMap)) {
        if (lowerName.includes(key)) {
          return emoji;
        }
      }
      return "📅";
    } catch (error) {
      console.error("Error getting holiday emoji:", error);
      return "📅";
    }
  };

  const getCampaignTip = () => {
    try {
      if (holidays.length === 0) {
        return "Plan your campaigns around upcoming holidays for better engagement";
      }
      const nextHoliday = holidays[0];
      return `Start planning ${
        nextHoliday?.name || "holiday"
      } templates now for approval`;
    } catch (error) {
      console.error("Error getting campaign tip:", error);
      return "Plan your campaigns around upcoming holidays for better engagement";
    }
  };

  return (
    <Box sx={{ bgcolor: "#FAFAFA", minHeight: "100vh" }}>
      {/* Top bar with phone number */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          px: "24px",
          py: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            bgcolor: "white",
            px: 2.5,
            py: 1,
            borderRadius: "8px",
            border: "1px solid #E1E8F2",
          }}
        >
          <Box
            sx={{
              height: 10,
              width: 10,
              bgcolor: "#008026",
              borderRadius: "50%",
              marginRight: "8px",
            }}
          />

          <Typography
            sx={{
              ...typography.bodyLarge,
              color: "#000000",
            }}
          >
            {isRCS ? "Brand Name" : "Primary Business"}
            {isRCS ? (
              <span
                style={{
                  ...typography.bodySmall,
                  color: "#505050",
                  marginLeft: 5,
                }}
              >
                {!brands
                  ? " Loading..."
                  : brands}
              </span>
            ) : (
              <span
                style={{
                  ...typography.bodySmall,
                  color: "#505050",
                  marginLeft: 5,
                }}
              >
                {loadingWabaPhone
                  ? " Loading..."
                  : formatPhoneNumber(wabaPhoneNumber)}
              </span>
            )}
          </Typography>
          <KeyboardArrowDownOutlinedIcon sx={{ color: grayFontColor }} />
        </Box>
      </Box>

      {/* Border line */}
      <Divider sx={{ borderColor: "#E1E8F2" }} />

      <Container
        disableGutters
        maxWidth={false}
        sx={{
          py: 3,
          maxWidth: "100%",
          width: "100%",
          paddingRight: "24px",
          paddingLeft: "24px",
          mt: 2,
        }}
      >
        <Grid disableGutters container spacing={3} sx={{ paddingX: "24px" }}>
          {/* Broadcasts Card */}
          {permissionsFromStorage.includes("broadcast.view") ? (
            <Grid item xs={12} md={6} xl={4}>
              <Card
                elevation={0}
                sx={{
                  border: "1px solid #E1E8F2",
                  height: "100%",
                  borderRadius: "4px",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <BroadcastLogo
                        sx={{
                          width: 19.5,
                          height: 18,
                        }}
                      />
                      <Typography sx={typography.h1}>Broadcasts</Typography>
                    </Box>
                    <ButtonOne
                      onClick={() => props.onNavigate("marketing_broadcast")}
                      isMobile={isMobile}
                      title={isMobile ? "New" : "Schedule New"}
                    />
                  </Box>
                  <Tabs
                    value={broadcastTab}
                    onChange={(e, v) => setBroadcastTab(v)}
                    TabIndicatorProps={{ style: { display: "none" } }}
                    variant="fullWidth"
                    sx={{
                      mb: 2,
                      minHeight: 36,
                      backgroundColor: "#F3F5F7",
                      borderRadius: "10px",
                      p: "4px",
                    }}
                  >
                    {["Last Broadcast", "This month", "Upcoming"].map(
                      (tab, index) => (
                        <DashboardTabLabel
                          tab={tab}
                          value={index}
                          key={index}
                        />
                      ),
                    )}
                  </Tabs>
                  {broadcastTab === 0 && (
                    <Box>
                      {/* Count / Loader */}
                      {!loadingLastBroadcastData ? (
                        <Typography sx={typography.statLarge}>
                          {lastBroadcastData.lastBroadcastCount ?? 0}
                        </Typography>
                      ) : (
                        <CircularProgress size={32} sx={{ mb: 1 }} />
                      )}

                      {/* Static label */}
                      <Typography
                        sx={{
                          ...typography.bodyLarge,
                          color: "#505050",
                          mb: 2,
                          mt: 2,
                        }}
                      >
                        messages delivered/read
                      </Typography>

                      {/* Last broadcast time */}
                      {!loadingLastBroadcastData ? (
                        <Typography
                          sx={{
                            ...typography.bodyLarge,
                            color: "#505050",
                            mb: 2,
                          }}
                        >
                          Last Broadcast on •{" "}
                          {lastBroadcastData.lastBroadcastTime
                            ? formatWithTzLabel(
                                lastBroadcastData.lastBroadcastTime,
                                "DD/MM/YYYY hh:mm:ss A",
                              )
                            : "N/A"}
                        </Typography>
                      ) : (
                        <CircularProgress size={20} />
                      )}
                    </Box>
                  )}

                  <DashboardStatSection
                    items={[
                      {
                        label: "Delivery Rate",
                        value: loadingDashboard
                          ? <Skeleton variant="text" width={60} />
                          : lastBroadcastData.lastBroadcastDeliveryRate !== undefined
                          ? `${Number(lastBroadcastData.lastBroadcastDeliveryRate).toFixed(2)}%`
                          : "0.00%",
                        valueColor: dashboardCardGreenTextColor,
                        Icon: loadingDashboard ? undefined : TrendingUpIcon,
                      },
                      ...(permissionsFromStorage.includes("whatsapp_billing.view")
                        ? [
                            {
                              label: "Total Cost",
                              value: loadingDashboard
                                ? <Skeleton variant="text" width={70} />
                                : lastBroadcastData.lastBroadcastCost !== undefined
                                ? `${getCurrencySymbol(billingCurrency)}${Number(lastBroadcastData.lastBroadcastCost).toFixed(2)}`
                                : `${getCurrencySymbol(billingCurrency)}0.00`,
                              valueColor: ColorsConstants.primaryBlue100,
                            },
                          ]
                        : []),
                    ]}
                  />

                  {broadcastTab === 1 && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "start",
                        gap: 2,
                        marginBottom: 2,
                        flexWrap: { sm: "nowrap", xs: "wrap" },
                      }}
                    >
                      <DashboardBadge
                        label=" Total Broadcasts"
                        value={loadingDashboard ? <Skeleton variant="text" width={40} /> : summaryData.totalBroadcasts}
                      />
                      <DashboardBadge
                        label="Avg. Delivery Rate"
                        value={loadingDashboard ? <Skeleton variant="text" width={50} /> : `${parseFloat(metrics.deliveryRate || 0).toFixed(2)}%`}
                        textColor={dashboardCardGreenTextColor}
                      />
                      {permissionsFromStorage.includes(
                        "whatsapp_billing.view",
                      ) && (
                        <DashboardBadge
                          label="Total Spend"
                          value={loadingDashboard ? <Skeleton variant="text" width={60} /> : formatCurrencySimple(usageData.totalCharges || 0)}
                        />
                      )}
                    </Box>
                  )}

                  {broadcastTab === 2 && (
                    <Box>
                      {scheduledBroadcasts.length > 0 ? (
                        scheduledBroadcasts.slice(0, 1).map((broadcast) => (
                          <Paper
                            key={broadcast.id}
                            elevation={0}
                            sx={{
                              bgcolor: "#e8f5e8",
                              border: "1px solid #c3e6c3",
                              p: 2,
                              mb: 2,
                            }}
                          >
                            <Typography
                              sx={{
                                ...typography.bodyLarge,
                                fontWeight: 600,
                                color: "success.main",
                                mb: 1,
                              }}
                            >
                              🎯 Next Scheduled
                            </Typography>
                            <Typography
                              sx={{
                                ...typography.bodyLarge,
                                color: "#505050",
                                mb: 1,
                              }}
                            >
                              {broadcast.campaign?.campaign_name ||
                                broadcast.template?.template_name ||
                                "Unnamed Campaign"}
                            </Typography>
                            <MetricRow
                              label="Recipients"
                              value={(
                                broadcast.phone_no_count || 0
                              ).toLocaleString()}
                            />
                            <MetricRow
                              label="Scheduled"
                              value={
                                broadcast.scheduled_datetime_iso
                                  ? formatWithTzLabel(
                                      broadcast.scheduled_datetime_iso,
                                    )
                                  : "No date set"
                              }
                            />
                            <MetricRow
                              label="Type"
                              value={
                                broadcast.scheduled_type === "recurring"
                                  ? "Recurring"
                                  : "One-time"
                              }
                            />
                            {broadcast.scheduled_type === "recurring" &&
                              broadcast.extras?.current_iteration_state
                                ?.current && (
                                <MetricRow
                                  label="Next Occurrence"
                                  value={format(
                                    parseISO(
                                      broadcast.extras.current_iteration_state
                                        .current,
                                    ),
                                    "MMM dd, yyyy",
                                  )}
                                />
                              )}
                          </Paper>
                        ))
                      ) : (
                        <Paper
                          elevation={0}
                          sx={{
                            bgcolor: "#f8f9fa",
                            border: "1px solid #e1e5e9",
                            p: 2,
                            textAlign: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              ...typography.bodyLarge,
                              color: "#505050",
                            }}
                          >
                            No scheduled broadcasts found
                          </Typography>
                        </Paper>
                      )}

                      {scheduledBroadcasts.length > 1 && (
                        <Box>
                          <Typography
                            sx={{
                              ...typography.h2,
                              mb: 1,
                              mt: 2,
                            }}
                          >
                            Upcoming Broadcasts
                          </Typography>
                          {scheduledBroadcasts
                            .slice(1, 3)
                            .map((broadcast, index) => (
                              <Paper
                                key={broadcast.id}
                                elevation={0}
                                sx={{
                                  p: 1.5,
                                  mb: 1,
                                  bgcolor: "#f8f9ff",
                                  border: "1px solid #e3e8ff",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Box sx={{ flex: 1 }}>
                                  <Typography
                                    sx={{
                                      ...typography.bodyLarge,
                                      fontWeight: 600,
                                      color: "#000000",
                                    }}
                                  >
                                    {broadcast.campaign?.campaign_name ||
                                      broadcast.template?.template_name ||
                                      "Unnamed Campaign"}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      ...typography.bodySmall,
                                      color: "#505050",
                                      mt: 0.5,
                                    }}
                                  >
                                    {broadcast.scheduled_datetime_iso
                                      ? formatWithTzLabel(
                                          broadcast.scheduled_datetime_iso,
                                        )
                                      : "No date set"}
                                  </Typography>
                                </Box>
                                <AppChip
                                  label={
                                    broadcast.scheduled_type === "recurring"
                                      ? "Recurring"
                                      : "One-time"
                                  }
                                  size="small"
                                  variant="outlined"
                                />
                              </Paper>
                            ))}

                          {scheduledBroadcasts.length > 3 && (
                            <Button
                              variant="text"
                              size="small"
                              fullWidth
                              onClick={() =>
                                props.onNavigate("campaign_management", {
                                  activeTab: 1,
                                })
                              }
                              sx={{
                                mt: 1,
                                ...typography.bodyLarge,
                                fontWeight: 600,
                              }}
                            >
                              View All Scheduled
                            </Button>
                          )}
                        </Box>
                      )}
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ) : (
            <Grid item xs={12} md={6} xl={4}>
              <Card
                elevation={0}
                sx={{
                  border: "1px solid #E1E8F2",
                  height: "100%",
                  borderRadius: "4px",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <BroadcastLogo
                        sx={{
                          width: 19.5,
                          height: 18,
                        }}
                      />
                      <Typography sx={typography.h1}>Broadcasts</Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 1,
                      mt: 16,
                    }}
                  >
                    <Lock
                      sx={{ height: "50px", width: "50px", color: "#424242" }}
                    />
                    <Typography
                      sx={{
                        ...typography.bodyLarge,
                        color: "#505050",
                        textAlign: "center",
                      }}
                    >
                      You do not have access to this feature
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )}

          {/* Wallet & Spend Card */}
          {permissionsFromStorage.includes("wallet_spend.view") ? (
            <Grid item xs={12} md={6} xl={4}>
              <Card
                elevation={0}
                sx={{
                  border: "1px solid #E1E8F2",
                  height: "100%",
                  borderRadius: "4px",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <WalletLogo width="19.5" height="18" />
                      <Typography sx={typography.h1}>Wallet & Spend</Typography>
                    </Box>
                    <ButtonTwo onClick={handleAddFunds} title={"Add Funds"} />
                  </Box>

                  {walletData?.unpaid_invoice && (
                    <Alert
                      severity="error"
                      sx={{
                        mb: 2,
                        justifyContent: "center",
                        alignItems: "center",
                        "& .MuiAlert-message": { flex: "unset" },
                        "& .MuiAlert-action": { paddingTop: 0, marginLeft: 1 },
                      }}
                      action={
                        <Button
                          color="inherit"
                          size="small"
                          onClick={() => props.onNavigate && props.onNavigate("billing_invoices")}
                        >
                          View Invoices
                        </Button>
                      }
                    >
                      You have an unpaid invoice. Please clear it to avoid service interruption.
                    </Alert>
                  )}

                  <Typography
                    sx={{
                      ...typography.bodySmall,
                      color: "#505050",
                      mb: 2,
                    }}
                  >
                    Current balance
                  </Typography>

                  <LinearProgress
                    variant="determinate"
                    value={
                      walletData
                        ? (walletData.monthly_spend /
                            (parseFloat(walletData.balance) +
                              walletData.monthly_spend)) *
                          100
                        : 0
                    }
                    sx={{
                      mb: "35px",
                      mt: "16px",
                      height: 8,
                      borderRadius: 3,
                      backgroundColor: ColorsConstants.secondaryGray,
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: ColorsConstants.primaryPurple100,
                        borderRadius: 3,
                      },
                    }}
                  />
                  <Typography
                    sx={{
                      ...typography.statLarge,

                      mb: 2,
                    }}
                  >
                    {loadingDashboard
                      ? <Skeleton variant="text" width={120} />
                      : walletData
                      ? formatCurrency(walletData.balance)
                      : formatCurrencySimple(0)}
                  </Typography>

                  <DashboardStatSection
                    items={[
                      {
                        label: "This Month",
                        value: loadingDashboard
                          ? <Skeleton variant="text" width={70} />
                          : formatCurrencySimple(parseFloat(currentMonthSpend || 0).toFixed(2)),
                      },
                      {
                        label: "Runway",
                        value: loadingDashboard
                          ? <Skeleton variant="text" width={40} />
                          : walletData?.runway || "0",
                      },
                      {
                        label: "Avg. per Message",
                        value: loadingDashboard
                          ? <Skeleton variant="text" width={60} />
                          : thisMonthUsageData.totalCharges > 0 && thisMonthUsageData.totalMessages > 0
                          ? `${getCurrencySymbol(billingCurrency)}${(thisMonthUsageData.totalCharges / thisMonthUsageData.totalMessages).toFixed(2)}`
                          : `${getCurrencySymbol(billingCurrency)}0.000`,
                        valueColor: dashboardCardGreenTextColor,
                        Icon: loadingDashboard ? undefined : TrendingUpIcon,
                      },
                    ]}
                  />
                </CardContent>
              </Card>
            </Grid>
          ) : (
            <Grid item xs={12} md={6} xl={4}>
              <Card
                elevation={0}
                sx={{
                  border: "1px solid #E1E8F2",
                  height: "100%",
                  borderRadius: "4px",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <WalletLogo width="19.5" height="18" />
                      <Typography sx={typography.h1}>Wallet & Spend</Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 1,
                      mt: 16,
                    }}
                  >
                    <Lock
                      sx={{ height: "50px", width: "50px", color: "#424242" }}
                    />
                    <Typography
                      sx={{
                        ...typography.bodyLarge,
                        color: "#505050",
                        textAlign: "center",
                      }}
                    >
                      You do not have access to this feature
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )}

          {/* Campaign Calendar Card */}
          {permissionsFromStorage.includes("campaign_calendar.view") ? (
            <Grid item xs={12} md={6} xl={4}>
              <Card
                elevation={0}
                sx={{
                  border: "1px solid #E1E8F2",
                  height: "100%",
                  borderRadius: "4px",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mr: "5px",
                      }}
                    >
                      <CalendarLogo width="19.5" height="18" />
                      <Typography sx={typography.h1}>
                        Campaign Calendar
                      </Typography>
                    </Box>

                    <AppDropdown
                      endIcon={
                        <KeyboardArrowDownOutlinedIcon
                          sx={{ color: grayFontColor }}
                        />
                      }
                      menuItems={HOLIDAY_COUNTRY_OPTIONS}
                      selectedValue={selectedCountry}
                      onMenuSelect={(value) =>
                        handleCountryChange({ target: { value } })
                      }
                      variant="outlined"
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        {HOLIDAY_COUNTRY_LABELS[selectedCountry] || ""}
                      </Box>
                    </AppDropdown>
                  </Box>

                  {loadingHolidays && (
                    <Box
                      sx={{ display: "flex", justifyContent: "center", py: 3 }}
                    >
                      <CircularProgress size={24} />
                    </Box>
                  )}

                  {!loadingHolidays && holidays.length === 0 && (
                    <Paper
                      elevation={0}
                      sx={{
                        bgcolor: "#f8f9fa",
                        border: "1px solid #e1e5e9",
                        p: 3,
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          ...typography.bodyLarge,
                          color: "#505050",
                        }}
                      >
                        No upcoming holidays found
                      </Typography>
                    </Paper>
                  )}

                  {!loadingHolidays &&
                    holidays.map((holiday, index) => (
                      <HolidayItem
                        key={`${holiday.date}-${index}`}
                        name={`${getHolidayEmoji(holiday.name)} ${holiday.name}`}
                        date={formatHolidayDate(holiday.date)}
                        daysLeft={holiday.days_remaining}
                        urgent={getUrgencyLevel(holiday.days_remaining)}
                      />
                    ))}

                  {!loadingHolidays && holidays.length > 4 && (
                    <Button
                      variant="text"
                      size="small"
                      fullWidth
                      sx={{
                        mt: 1,
                        ...typography.bodyLarge,
                        fontWeight: 600,
                      }}
                      onClick={() =>
                        props.onNavigate && props.onNavigate("holidays")
                      }
                    >
                      View All {holidays.length} Holidays
                    </Button>
                  )}

                  <Paper
                    elevation={0}
                    sx={{
                      bgcolor: "#fff3cd",
                      border: "1px solid #ffeaa7",
                      p: 1.5,
                      mt: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        ...typography.bodySmall,
                        fontWeight: 600,
                        color: "#856404",
                        mb: 0.5,
                      }}
                    >
                      💡 Campaign Tip
                    </Typography>
                    <Typography
                      sx={{
                        ...typography.bodySmall,
                        color: "#856404",
                      }}
                    >
                      {getCampaignTip()}
                    </Typography>
                  </Paper>
                </CardContent>
              </Card>
            </Grid>
          ) : (
            <Grid item xs={12} md={6} xl={4}>
              <Card
                elevation={0}
                sx={{
                  border: "1px solid #E1E8F2",
                  height: "100%",
                  borderRadius: "4px",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <CalendarLogo width="19.5" height="18" />
                      <Typography sx={typography.h1}>
                        Campaign Calendar
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 1,
                      mt: 16,
                    }}
                  >
                    <Lock
                      sx={{ height: "50px", width: "50px", color: "#424242" }}
                    />
                    <Typography
                      sx={{
                        ...typography.bodyLarge,
                        color: "#505050",
                        textAlign: "center",
                      }}
                    >
                      You do not have access to this feature
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )}

          {/* Contacts & Growth Card */}
          {permissionsFromStorage.includes("contacts_growth.view") ? (
            <Grid item xs={12} md={6} xl={4}>
              <Card
                elevation={0}
                sx={{
                  border: "1px solid #E1E8F2",
                  height: "100%",
                  borderRadius: "4px",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <ContactsLogo width="19.5" height="18" />
                      <Typography sx={typography.h1}>
                        Contacts & Growth
                      </Typography>
                    </Box>
                    <ButtonTwo
                      onClick={() => props.onNavigate("audience")}
                      title={"Import"}
                    />
                  </Box>

                  <Tabs
                    value={contactsTab}
                    onChange={(e, v) => setContactsTab(v)}
                    TabIndicatorProps={{ style: { display: "none" } }}
                    variant="fullWidth"
                    sx={{
                      mb: 2,
                      minHeight: 36,
                      backgroundColor: "#F3F5F7",
                      borderRadius: "10px",
                      p: "4px",
                    }}
                  >
                    {["Active", "Growth", "Regions"].map((tab, index) => (
                      <DashboardTabLabel tab={tab} value={index} key={index} />
                    ))}
                  </Tabs>

                  {contactsTab === 0 && (
                    <Box>
                      <Typography sx={typography.statLarge}>
                        {loadingDashboard ? <Skeleton variant="text" width={80} /> : audienceData?.active || 0}
                      </Typography>
                      <Typography
                        sx={{
                          ...typography.bodyLarge,
                          color: "#505050",
                          mb: 2,
                          mt: 1,
                        }}
                      >
                        contacts engaged in the current month
                      </Typography>
                      <MetricRow
                        label="Quarter to Date"
                        value={loadingDashboard ? <Skeleton variant="text" width={60} /> : audienceData?.quarter_to_date || 0}
                      />
                      <Divider />
                      <MetricRow
                        label="Year to Date"
                        value={loadingDashboard ? <Skeleton variant="text" width={60} /> : audienceData?.year_to_date || 0}
                      />
                      <Divider />
                      <MetricRow
                        label="Tag count"
                        value={loadingDashboard ? <Skeleton variant="text" width={40} /> : audienceData?.audience_tags || 0}
                      />
                    </Box>
                  )}

                  {contactsTab === 1 && (
                    <Box>
                      <MetricRow
                        label="New This Month"
                        value={loadingDashboard ? <Skeleton variant="text" width={60} /> : audienceData?.active || 0}
                      />
                      <Divider />
                      <MetricRow
                        label="New This month from chatbot"
                        value={loadingDashboard ? <Skeleton variant="text" width={60} /> : audienceData?.new_this_month_from_chatbot || 0}
                      />
                      <Divider />
                      <MetricRow
                        label="New Last Month"
                        value={loadingDashboard ? <Skeleton variant="text" width={60} /> : audienceData?.new_last_month || 0}
                        color="success.main"
                      />
                      <Divider />
                      <MetricRow
                        label="Growth"
                        value={
                          loadingDashboard
                            ? <Skeleton variant="text" width={50} />
                            : audienceData.growth !== undefined
                            ? `${Number(audienceData.growth).toFixed(2)}%`
                            : `0.00`
                        }
                      />
                    </Box>
                  )}

                  {contactsTab === 2 && (
                    <Box>
                      {audienceData?.regions?.data &&
                      audienceData.regions.data.length > 0 ? (
                        <>
                          {audienceData.regions.data.map((region, index) => (
                            <React.Fragment key={region.country || index}>
                              <MetricRow
                                label={
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                    }}
                                  >
                                    {region.flag && <span>{region.flag}</span>}
                                    <span>{region.country || "Unknown"}</span>
                                  </Box>
                                }
                                value={`${(
                                  region.count || 0
                                ).toLocaleString()} (${(
                                  region.percentage || 0
                                ).toFixed(1)}%)`}
                              />
                              {index < audienceData.regions.data.length - 1 && (
                                <Divider />
                              )}
                            </React.Fragment>
                          ))}

                          {audienceData?.regions?.total !== undefined && (
                            <>
                              <Divider />
                              <MetricRow
                                label="Total Contacts"
                                value={audienceData.regions.total.toLocaleString()}
                                color={ColorsConstants.primaryBackgroundColor}
                              />
                            </>
                          )}
                        </>
                      ) : (
                        <Typography
                          sx={{
                            ...typography.bodyLarge,
                            color: "#505050",
                            textAlign: "center",
                          }}
                        >
                          No region data available
                        </Typography>
                      )}
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ) : (
            <Grid item xs={12} md={6} xl={4}>
              <Card
                elevation={0}
                sx={{
                  border: "1px solid #E1E8F2",
                  height: "100%",
                  borderRadius: "4px",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <ContactsLogo width="19.5" height="18" />
                      <Typography sx={typography.h1}>
                        Contacts & Growth
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 1,
                      mt: 16,
                    }}
                  >
                    <Lock
                      sx={{ height: "50px", width: "50px", color: "#424242" }}
                    />
                    <Typography
                      sx={{
                        ...typography.bodyLarge,
                        color: "#505050",
                        textAlign: "center",
                      }}
                    >
                      You do not have access to this feature
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )}

          {/* Account Status Card */}
          {permissionsFromStorage.includes("account_status.view") ? (
            <Grid item xs={12} md={6} xl={4}>
              <Card
                elevation={0}
                sx={{
                  border: "1px solid #E1E8F2",
                  height: "100%",
                  borderRadius: "4px",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <SettingsLogo width="19.5" height="18" />
                      <Typography sx={typography.h1}>Account Status</Typography>
                    </Box>
                    <ButtonTwo
                      onClick={() =>
                        props.onNavigate && props.onNavigate("billing_settings")
                      }
                      title={"Manage"}
                    />
                  </Box>

                  <MetricRow
                    label="WhatsApp API"
                    value={
                      loadingDashboard
                        ? <Skeleton variant="text" width={90} />
                        : <Box sx={{ display: "flex", alignItems: "center" }}>
                            <StatusIndicator
                              status={businessData?.wabaInfo?.dockerStatus?.toLowerCase()}
                            />
                            {businessData?.wabaInfo?.dockerStatus
                              ? formatStatus(businessData.wabaInfo.dockerStatus)
                              : "Disconnected"}
                          </Box>
                    }
                    color={
                      businessData?.wabaInfo?.dockerStatus === "CONNECTED"
                        ? "success.main"
                        : "error.main"
                    }
                  />
                  <Divider />
                  <MetricRow
                    label="Messaging Limit"
                    value={loadingDashboard ? <Skeleton variant="text" width={100} /> : formatStatus(businessData?.wabaInfo?.messagingLimit)}
                  />
                  <MetricRow
                    label="Account Status"
                    value={loadingDashboard ? <Skeleton variant="text" width={80} /> : formatStatus(businessData?.wabaInfo?.accountStatus)}
                  />
                  <MetricRow
                    label="Can Send Message"
                    value={loadingDashboard ? <Skeleton variant="text" width={40} /> : formatStatus(businessData?.wabaInfo?.canSendMessage)}
                  />
                  <MetricRow
                    label="mmLiteStatus"
                    value={loadingDashboard ? <Skeleton variant="text" width={80} /> : formatStatus(businessData?.wabaInfo?.mmLiteStatus)}
                  />
                  <MetricRow
                    label="Phone Quality"
                    value={loadingDashboard ? <Skeleton variant="text" width={60} /> : formatStatus(businessData?.wabaInfo?.phoneQuality)}
                    color={
                      businessData?.wabaInfo?.phoneQuality === "GREEN"
                        ? "success.main"
                        : "warning.main"
                    }
                  />
                  <MetricRow
                    label="Verification Status"
                    value={loadingDashboard ? <Skeleton variant="text" width={80} /> : formatStatus(businessData?.wabaInfo?.verificationStatus)}
                  />
                </CardContent>
              </Card>
            </Grid>
          ) : (
            <Grid item xs={12} md={6} xl={4}>
              <Card
                elevation={0}
                sx={{
                  border: "1px solid #E1E8F2",
                  height: "100%",
                  borderRadius: "4px",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <SettingsLogo width="19.5" height="18" />
                      <Typography sx={typography.h1}>Account Status</Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 1,
                      mt: 16,
                    }}
                  >
                    <Lock
                      sx={{ height: "50px", width: "50px", color: "#424242" }}
                    />
                    <Typography
                      sx={{
                        ...typography.bodyLarge,
                        color: "#505050",
                        textAlign: "center",
                      }}
                    >
                      You do not have access to this feature
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )}

          {/* Quick Insights Card */}
          {permissionsFromStorage.includes("quick_insights.view") ? (
            <Grid item xs={12} md={6} xl={4}>
              <Card
                elevation={0}
                sx={{
                  border: "1px solid #E1E8F2",
                  height: "100%",
                  borderRadius: "4px",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <GraphLogo width="19.5" height="18" />
                      <Typography sx={typography.h1}>Quick Insights</Typography>
                    </Box>
                    <ButtonTwo
                      onClick={() => {
                        props.onNavigate &&
                          props.onNavigate("template_analytics");
                        localStorage.setItem("activeSection", "analytics");
                        localStorage.setItem(
                          "activePage",
                          "template_analytics",
                        );
                      }}
                      title={isMobile ? "View" : "View Analytics"}
                    />
                  </Box>

                  <MetricRow
                    label="Response Rate (7d)"
                    value="24.30%"
                    color="success.main"
                    trend="up"
                  />
                  <Divider />
                  <MetricRow label="Best Performing" value="Media Messages" />
                  <Divider />
                  <MetricRow label="Peak Activity" value="2-4 PM IST" />
                  <Divider />
                  <MetricRow
                    label="Failed Messages"
                    value="127"
                    color="error.main"
                    trend="down"
                  />
                  <MetricRow
                    label="Templates"
                    value={loadingDashboard
                      ? <Skeleton variant="text" width={160} />
                      : `${templateStatus.approved} Approved • ${templateStatus.pending} Pending`}
                  />
                </CardContent>
              </Card>
            </Grid>
          ) : (
            <Grid item xs={12} md={6} xl={4}>
              <Card
                elevation={0}
                sx={{
                  border: "1px solid #E1E8F2",
                  height: "100%",
                  borderRadius: "4px",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <GraphLogo width="19.5" height="18" />
                      <Typography sx={typography.h1}>Quick Insights</Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 1,
                      mt: 16,
                    }}
                  >
                    <Lock
                      sx={{ height: "50px", width: "50px", color: "#424242" }}
                    />
                    <Typography
                      sx={{
                        ...typography.bodyLarge,
                        color: "#505050",
                        textAlign: "center",
                      }}
                    >
                      You do not have access to this feature
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>

        {/* Add Funds Modal */}
        <Dialog
          open={showAddFundsModal}
          onClose={handleCancel}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={typography.h1}>Add Funds</Typography>
            <IconButton onClick={handleCancel} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Amount to Add"
              type="number"
              fullWidth
              variant="outlined"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {getCurrencySymbol(billingCurrency)}
                  </InputAdornment>
                ),
              }}
              sx={{ mt: 2 }}
              helperText="Enter the amount you want to add to your wallet"
              InputLabelProps={{ sx: typography.bodyLarge }}
              inputProps={{ sx: typography.bodyLarge }}
            />
          </DialogContent>
          <DialogActions sx={{ p: 3 }}>
            <Button
              onClick={handleCancel}
              variant="outlined"
              sx={typography.bodyLarge}
            >
              Cancel
            </Button>
            <Button
              onClick={handleAmountSubmit}
              variant="contained"
              disabled={!amount || parseFloat(amount) <= 0}
              sx={{
                ml: 2,
                ...typography.bodyLarge,
                fontWeight: 600,
              }}
            >
              Continue
            </Button>
          </DialogActions>
        </Dialog>

        {/* Confirm Transaction Modal */}
        <Dialog
          open={showConfirmModal}
          onClose={handleCancel}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={typography.h1}>Confirm Transaction</Typography>
            <IconButton
              onClick={handleCancel}
              size="small"
              disabled={submitting}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: "#505050",
                mb: 3,
              }}
            >
              Are you sure you want to add the following amount to your wallet?
            </Typography>
            <Card sx={{ bgcolor: "#f8f9fa" }}>
              <CardContent>
                <Typography
                  sx={{
                    ...typography.bodySmall,
                    color: "#505050",
                  }}
                >
                  Amount to Add
                </Typography>
                <Typography
                  sx={{
                    ...typography.h1,
                    fontSize: "24px",
                    fontWeight: 700,
                    mt: 1,
                  }}
                >
                  {amount && formatCurrency(parseFloat(amount))}
                </Typography>
                <Typography
                  sx={{
                    ...typography.bodySmall,
                    color: "#505050",
                    mt: 1,
                  }}
                >
                  Payment Method: Bank Transfer
                </Typography>
              </CardContent>
            </Card>
          </DialogContent>
          <DialogActions sx={{ p: 3 }}>
            <Button
              onClick={handleCancel}
              variant="outlined"
              fullWidth
              disabled={submitting}
              sx={typography.bodyLarge}
            >
              Cancel
            </Button>
            <Button
              onClick={handleConfirm}
              variant="contained"
              fullWidth
              disabled={submitting}
              sx={{
                ml: 2,
                bgcolor: "#2e7d32",
                "&:hover": { bgcolor: "#1b5e20" },
                ...typography.bodyLarge,
                fontWeight: 600,
              }}
            >
              {submitting ? (
                <>
                  <CircularProgress size={20} sx={{ mr: 1 }} />
                  Processing...
                </>
              ) : (
                "Confirm & Add Funds"
              )}
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Box>
  );
};

export default DashboardTab;
